/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessCategorySummary
 */
export interface BusinessCategorySummary {
    /**
     * メインビジネスカテゴリID
     * @type {string}
     * @memberof BusinessCategorySummary
     */
    busiCateId: string;
    /**
     * ビジネスカテゴリのID
     * @type {number}
     * @memberof BusinessCategorySummary
     */
    busiCateLv2Id: number;
    /**
     * ビジネスカテゴリ名
     * @type {string}
     * @memberof BusinessCategorySummary
     */
    busiCateLv2Name: string;
    /**
     * ビジネスカテゴリを設定して配信されたプレスリリース数（過去全て累積）
     * @type {number}
     * @memberof BusinessCategorySummary
     */
    releaseCount: number;
    /**
     * ビジネスカテゴリをフォローしているメディアユーザー数
     * @type {number}
     * @memberof BusinessCategorySummary
     */
    followingCount: number;
    /**
     * ビジネスカテゴリをフォローしているかどうか
     * @type {boolean}
     * @memberof BusinessCategorySummary
     */
    isFollowing: boolean;
}

export function BusinessCategorySummaryFromJSON(json: any): BusinessCategorySummary {
    return BusinessCategorySummaryFromJSONTyped(json, false);
}

export function BusinessCategorySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessCategorySummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'busiCateId': json['busi_cate_id'],
        'busiCateLv2Id': json['busi_cate_lv2_id'],
        'busiCateLv2Name': json['busi_cate_lv2_name'],
        'releaseCount': json['release_count'],
        'followingCount': json['following_count'],
        'isFollowing': json['is_following'],
    };
}

export function BusinessCategorySummaryToJSON(value?: BusinessCategorySummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'busi_cate_id': value.busiCateId,
        'busi_cate_lv2_id': value.busiCateLv2Id,
        'busi_cate_lv2_name': value.busiCateLv2Name,
        'release_count': value.releaseCount,
        'following_count': value.followingCount,
        'is_following': value.isFollowing,
    };
}

